import $ from 'jquery'
import _ from 'lodash'
import {padToFour, getUrlVars} from './common'

function doSearchByUrlParams(urlVars, dataTable) {

  const rawSearchValue = _.get(urlVars, 'rawSearchValue')

  if (rawSearchValue) {
    dataTable.search(rawSearchValue).draw()
  } else {
    _.forEach(urlVars, (value, key) => {
      const searchField = $(`[name='${ key }']`)
      searchField.val(value)
      dataTable.search(JSON.stringify(urlVars)).draw()
    })
  }

}

const initDatatable = () => {

  // setting special ago ordering
  $.extend($.fn.dataTableExt.oSort, {
    'num-ago-pre': (a) => {
      const nonNumbersConcatenated = a.replace(/\D/g, ' ')
      const splitted = nonNumbersConcatenated.match(/\S+/g) || []
      const splittedPadded = $.map(splitted, (val) => {
        return padToFour(val)
      })
      return `${splittedPadded }`
    }
  })

}

$.fn.listingClientSideDataTable = (options) => {
  const defaultOptions = {
    serverSide: false,
    fnInitComplete: () => {}
  }

  const finalOptions = $.extend({}, defaultOptions, options)

  $(this).listingDataTable(finalOptions)
}

$.fn.listingDataTable = function init(options) {
  const urlVars = getUrlVars()
  const table = this
  const fieldId = table.attr('id')

  const defaultOptions = {
    fnDrawCallback: function() {
      $('div.length-control select').material_select()
    },
    dom: "<'row'<'col s6 length-control'l><'col s3 right'f>><t>i<'right'p><'clearfix'>",
    buttons: null,
    language: {
      sEmptyTable: 'Nincs rendelkezésre álló adat',
      sInfo: 'Találatok: _START_ - _END_ Összesen: _TOTAL_',
      sInfoEmpty: 'Nincs találat',
      sInfoFiltered: '(_MAX_ összes rekord közül szűrve)',
      sInfoPostFix: '',
      sInfoThousands: ' ',
      sLengthMenu: '_MENU_',
      sLoadingRecords: 'Betöltés...',
      sProcessing: 'Feldolgozás...',
      search: 'Keresés:',
      sZeroRecords: 'Nincs a keresésnek megfelelő találat',
      oPaginate: {
        sFirst: 'Első',
        sPrevious: 'Előző',
        sNext: 'Következő',
        sLast: 'Utolsó'
      },
      oAria: {
        sSortAscending: ': aktiválja a növekvő rendezéshez',
        sSortDescending: ': aktiválja a csökkenő rendezéshez'
      }
    },
    ordering: false,
    serverSide: true,
    processing: true,
    conditionalPaging: true,
    responsive: true,
    autoWidth: false,
    useUrlVars: true,
    searchDelay: '500',
    columnFilters: [],
    pageLength: 10,
    lengthMenu: [[10, 25, 50, 100, -1], [
      '10 találat oldalanként',
      '25 találat oldalanként',
      '50 találat oldalanként',
      '100 találat oldalanként',
      'Összes találat megjelenítése egy oldalon'
    ]]
  }

  const finalOptions = $.extend({}, defaultOptions, options)

  const dataTableInstance = table.DataTable(finalOptions)

  dataTableInstance.on('init.dt', (event, settings, json) => {
    $('.js-datatables-loader').hide()
    if (_.get(json, 'data.length')) {
      $('.js-datatables-not-empty').show()
    } else {
      $('.js-datatables-empty').show()
    }
  })

  function switchFilterToExtended(selector) {
    const newFilter = $(selector)
    const originalFilter = $(`#${fieldId}_filter`)
    newFilter.insertAfter(originalFilter)
    var $inputs = $(`${selector} input`)
    $inputs.attr('maxlength', '128')
    $inputs.attr('data-for', fieldId)
    originalFilter.css('opacity', '0.5')
    originalFilter.remove()
    newFilter.show()
  }

  function updateQueryStringParameter(uri, key, value) {
    const re = new RegExp(`([?&])${ key }=.*?(&|$)`, 'i')
    const separator = uri.indexOf('?') !== -1 ? '&' : '?'
    if (uri.match(re)) {
      return uri.replace(re, `$1${ key }=${ value }$2`)
    }
    return `${uri + separator + key }=${ value}`
  }

  function extendQueryStringWithSearchParams(searchParams) { // eslint-disable-line
    let newPath = window.location.pathname
    const searchJSON = (() => {
      try {
        return JSON.parse(searchParams)
      } catch (e) {
        return {'rawSearchValue': searchParams}
      }
    })()
    _.forEach(searchJSON, (value, key) => {
      if (value.length > 0) {
        newPath = updateQueryStringParameter(newPath, encodeURIComponent(key), encodeURIComponent(value))
      }
    })
    window.history.replaceState(null, null, newPath)
  }

  function getFilterInputs() {
    return $(`.dt-filter-input[data-for=${fieldId}`)
  }

  function getSearchCell(columnId, visible) {
    let defaultValue = _.get(urlVars, columnId)
    const hidden = (() => {
      if (!visible) {
        return 'hidden'
      }
      return ''
    })()

    if (!defaultValue) {
      defaultValue = ''
    }
    const id = `dt-filter-${columnId}`
    return `<input type="text" name="${columnId}" ${hidden} value="${defaultValue}" id="${id}" class="dt-filter-input" maxlength="64" data-for="${fieldId}" />`
  }

  function getColumnFilter(columnFilters, columnId) {
    const columnFilterObjects = _.map(columnFilters, (columnFilter) => {
      if (typeof columnFilter === 'string') {
        return {
          'type': 'input',
          'columnId': columnFilter
        }
      }
      return columnFilter
    })
    return _.find(columnFilterObjects, (columnFilterObject) => {
      return columnFilterObject.columnId === columnId
    })
  }

  function addColumnFilters(columnFilters) {
    if (!columnFilters) return

    let columnsStr = '<tr role="filter">'
    dataTableInstance.columns().every((index) => {
      const column = dataTableInstance.column(index)
      const columnId = column.dataSrc()
      const columnFilterObject = getColumnFilter(columnFilters, columnId)

      columnsStr += '<th>'
      if (columnFilterObject) {
        if (columnFilterObject.type === 'input') {
          const columnIsVisible = column.visible()
          columnsStr += getSearchCell(columnId, columnIsVisible)
        }
        if (columnFilterObject.type === 'select') {
          const filterId = `dt-filter-${columnId}`
          columnsStr += `<select class="dt-select show-tick dt-filter-input" name="${columnId}" id="${filterId}" data-for="${fieldId}">`
          columnsStr += `<option value=""></option>`
          _.each(columnFilterObject.values, (value, key) => {
            columnsStr += `<option value="${key}">${value}</option>`
          })
          columnsStr += `</select>`
        }
      }
      columnsStr += '</th>'
    })
    columnsStr += '</tr>'

    table.find('thead tr').after(columnsStr)
  }

  function doFilteringServerSide() {
    const postData = {}
    getFilterInputs().each((i, element) => {
      const field = $(element)
      const fieldVal = _.replace(field.val(), /;/g, '') // TODO semicolon cleanup
      if (fieldVal) {
        postData[field.attr('name')] = fieldVal
      }
    })
    dataTableInstance.search(JSON.stringify(postData))
    dataTableInstance.draw()
  }

  function doFilteringClientSide($field) {
    const fieldColumnId = $field[0].name

    dataTableInstance.columns().every(() => {
      const column = this
      const columnId = column.dataSrc()

      if (columnId === fieldColumnId) {
        column.search($field.context.value)
        .draw()
      }
    })
  }

  function doFiltering($field) {
    if (finalOptions.serverSide) {
      doFilteringServerSide()
    } else {
      doFilteringClientSide($field)
    }
  }

  function setFilterListeners() {
    const inputs = getFilterInputs().filter('input')
    inputs.keydown((event) => {
      const $field = $(this)
      if (event.keyCode === 13) { // enter
        doFiltering($field)
      }
    })

    let timeout = false
    inputs.keyup((e) => {
      const $input = $(e.currentTarget)

      if (timeout) {
        clearTimeout(timeout)
      }
      timeout = setTimeout(() => {
        doFiltering($input)
      }, 250)
      return timeout
    })

    getFilterInputs().filter('select').change((event) => {
      doFiltering($(event.currentTarget))
    })
  }

  if (!finalOptions.serverSide) {

    if (finalOptions.switchToExtendedFilter) {
      const extendedFilterSelector = finalOptions.switchToExtendedFilter
      switchFilterToExtended(extendedFilterSelector)
    }

    addColumnFilters(finalOptions.columnFilters)

    setFilterListeners(finalOptions.serverSide)
  }

  if (urlVars && finalOptions.useUrlVars) {
    doSearchByUrlParams(urlVars, dataTableInstance)
  }

  dataTableInstance.on('search.dt', () => {
    // disable for now, it's not working good enough with the column filters yet
    // extendQueryStringWithSearchParams(dataTableInstance.search())
  })

  dataTableInstance.on('init.dt', () => {

    if (finalOptions.switchToExtendedFilter) {
      const extendedFilterSelector = finalOptions.switchToExtendedFilter
      switchFilterToExtended(extendedFilterSelector)
    }

    if (finalOptions.columnFilters.length) {
      addColumnFilters(finalOptions.columnFilters)
    }

    setFilterListeners()
  })

  dataTableInstance.on('processing.dt', (e, s, processing) => {
    $(e.currentTarget).css('opacity', processing ? '0.5' : '1')
  })
  return dataTableInstance
}

$(document).ready(() => {
  initDatatable()
})



// WEBPACK FOOTER //
// ./src/common/datatable.js